



























import Vue from 'vue'
import { User } from '@/interfaces/app/Auth'

export default Vue.extend({
  computed: {
    sidebar: {
      get(): boolean {
        return this.$store.getters['app/sidebar']
      },
      set(value: boolean): void {
        this.$store.commit('app/setSidebar', value)
      },
    },
    user(): User {
      return this.$store.getters['user/user']
    },
  },
  methods: {
    logout(): void {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push({ name: 'login' })
      })
    },
  },
})
